import { InteractivityPoll } from 'modules/AnchorAPI/v3/episodes/fetchInteractivityPoll';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { AnchorAPI } from 'modules/AnchorAPI';

export const INTERACTIVE_POLL_KEY = 'INTERACTIVE_POLL_KEY';

export function useFetchPoll(episodeId: string) {
  const { data, status } = useQuery([INTERACTIVE_POLL_KEY, episodeId], () =>
    AnchorAPI.fetchInteractivityPoll(episodeId)
  );
  return { data, status };
}

export function useDeletePoll() {
  const queryClient = useQueryClient();
  const { mutate, status } = useMutation(
    ({ episodeId, userId }: { episodeId: string; userId: number }) =>
      AnchorAPI.deleteInteractivityPoll(episodeId, userId),
    {
      onSuccess: (res, { episodeId }) => {
        return queryClient.invalidateQueries([INTERACTIVE_POLL_KEY, episodeId]);
      },
    }
  );
  return { deletePoll: mutate, status };
}

export function useUpdatePoll() {
  const queryClient = useQueryClient();
  const { mutate, status } = useMutation(
    ({
      episodeId,
      poll: updates,
    }: {
      episodeId: string;
      poll: Partial<InteractivityPoll>;
    }) => AnchorAPI.updateInteractivityPoll(episodeId, updates),
    {
      onSuccess: (res, { episodeId }) => {
        return queryClient.invalidateQueries([INTERACTIVE_POLL_KEY, episodeId]);
      },
    }
  );
  return { updatePoll: mutate, status };
}
